const getSource = () => {
  const urlQuery = new URLSearchParams(window.location.search)
  const source = urlQuery.get('source')?.toString()
  return source
}
export default getSource
